import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { login, LoginService } from './jkUser';
import { jkRestReturn } from './jkInterface';
import { StorageService } from './storage.service';
import { JkpowerService } from './jkpower.service';
import { jkRestReturnClass } from './jkClass';


const defaultPath = '/';

@Injectable()
export class AuthService {
  //loggedIn = false; // JACKIE MODI
  storage: StorageService;
  power: JkpowerService = new JkpowerService();
  private _lastAuthenticatedPath: string = defaultPath;
  public login: LoginService; //= inject(LoginService);
  public router: Router = inject(Router);
  constructor() {
    //this.storage = new Storage();
    this.login = login;
    this.storage = new StorageService();
  }
  get loggedIn(): boolean {
    //return !!this._user;
    return this.login.isLogin;
  }
  set loggedIn(b: boolean) {
    this.login.isLogin = b;
  }
  set lastAuthenticatedPath(value: string) {
    // eslint-disable-next-line no-underscore-dangle
    this._lastAuthenticatedPath = value;
  }
  async setToken(token: string) {
    return await this.storage.setItem('auth-token', token);
  }

  async getToken() {
    return await this.storage.getItem('auth-token');
  }

  async deleteToken() {
    await this.storage.removeItem('auth-token');
  }

  async getPayload() {
    const token = await this.storage.getItem('auth-token');
    let payload;
    if (token) {
      payload = token.split('.')[1];
      payload = JSON.parse(window.atob(payload));
    }

    return payload.data;
  }

  async logIn(login: string, email: string, passord: string, navigateTo: string,
    hostName: string, token: string, autoLogin: boolean, ret: jkRestReturn): Promise<boolean> {
    /*let retLogin =  await Login.logIn(login,email,passord,hostName,token,autoLogin);
    //debugger;
    if(retLogin.result){
      this.loggedIn = true;

    }else
      this.loggedIn = false;*/
    if (autoLogin && this.login.isLogin) {
      // TODO : 檢查 自動登入是否過期
      // this.loggedIn = true;
    } else {
      const loggedIn = await this.login.logIn(login, email, passord, token, autoLogin, ret);
      if (loggedIn) {
        this.router.navigate([navigateTo]);
      }

    }
    return this.loggedIn;
  }

  logOut() {
    const mRet: boolean = this.login.logout(this.login.hostName);
    if (mRet) {
      this.loggedIn = false;
      this.router.navigate(['/login-form']);
    }
    return this.loggedIn;
  }

  isLoggedIn() {
    if (this.login.autoLogin && this.login.isLogin) {
      // TODO : 檢查 自動登入是否過期
      this.loggedIn = true;
    }

    return this.loggedIn;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService extends AuthService implements CanActivate {
  //public override router: Router, public login: LoginService
  constructor() {
    super();
  }
  // get loggedIn(): boolean {
  //   //return !!this._user;
  //   return Login.isLogin;
  // }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const isLoggedIn = this.isLoggedIn();
    let ret: jkRestReturn = new jkRestReturnClass();
    //const isAuthForm = route.routeConfig.path === 'login-form';
    //const isAuthForm = route.routeConfig.path === 'login';

    const isAuthForm = [
      'login-form',
      'reset-password',
      'create-account',
      'change-password/:recoveryCode'
    ].includes(route.routeConfig?.path || defaultPath);
    // jackie 20260210 add begin
    const path = route.routeConfig?.path || defaultPath;
    let bool = await this.power.setPower(path, this.login, ret, true);
    if (!bool) {
      alert('沒有權限進入此頁面!(' + path + ')');
      return false;
    };
    // jackie 20260210 add end
    if (isLoggedIn && isAuthForm) {
      this.lastAuthenticatedPath = defaultPath;
      this.router.navigate([defaultPath]);
      return false;
    }

    if (!isLoggedIn && !isAuthForm) {
      this.router.navigate(['/login-form']);
      //this.router.navigate(['/login']);
    }
    if (isLoggedIn) {
      this.lastAuthenticatedPath = route.routeConfig?.path || defaultPath;
    }

    return isLoggedIn || isAuthForm;
  }
}
